import { BoardManager } from "./BoardManager";
import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";
import { AudioManager } from "../../AudioManager";
import { GameManager } from "../../GameManager";

export class GUI extends Phaser.Group {

    private emoji: Phaser.Image;
    private audioOnButton: Phaser.Button;
    private audioOffButton: Phaser.Button;
    private emojiPressed: boolean;
    private f: number;

    constructor(game: Phaser.Game) {

        super(game, null, "gui");

        this.emojiPressed = false;
        this.f = 0;

        const pauseButton = new Phaser.Button(this.game, 50, 50 * GameVars.scaleY, "texture_atlas_1", this.onClickPause, this);
        pauseButton.setFrames("btn_menu", "btn_menu", "btn_menu", "btn_menu");
        pauseButton.anchor.set(.5);
        pauseButton.scale.y = GameVars.scaleY;
        this.add(pauseButton);

        this.emoji = new Phaser.Image(this.game, GameConstants.GAME_WIDTH / 2, 65 * GameVars.scaleY, "texture_atlas_1", "normal");
        this.emoji.anchor.set(.5);
        this.emoji.scale.y = GameVars.scaleY;
        this.emoji.inputEnabled = true;
        this.emoji.events.onInputDown.add(this.onDownEmoji, this);
        this.emoji.events.onInputUp.add(this.onUpEmoji, this);
        this.emoji.events.onInputOver.add(() => {
            this.emoji.scale.set(1.1);
        }, this);
        this.emoji.events.onInputOut.add(() => {
            this.emoji.scale.set(1);
        }, this);
        this.add(this.emoji);

        this.audioOnButton = new Phaser.Button(this.game,  GameConstants.GAME_WIDTH - 50, 50 * GameVars.scaleY, "texture_atlas_1", this.onClickAudioButton, this);
        this.audioOnButton.setFrames( "btn_sound_on", "btn_sound_on", "btn_sound_on", "btn_sound_on");
        this.audioOnButton.anchor.set(.5);
        this.audioOnButton.scale.y = GameVars.scaleY;
        this.add(this.audioOnButton);

        this.audioOffButton = new Phaser.Button(this.game, GameConstants.GAME_WIDTH - 50, 50 * GameVars.scaleY, "texture_atlas_1", this.onClickAudioButton, this);
        this.audioOffButton.setFrames( "btn_sound_off", "btn_sound_off", "btn_sound_off", "btn_sound_off");
        this.audioOffButton.anchor.set(.5);
        this.audioOffButton.scale.y = GameVars.scaleY;
        this.add(this.audioOffButton);

        if (GameVars.gameData && GameVars.gameData.muted) {
            this.audioOnButton.visible = false;
            this.audioOffButton.visible = true;
        } else {
            this.audioOnButton.visible = true;
            this.audioOffButton.visible = false;
        }
    }

    public update(): void {

        super.update();

        if (this.emojiPressed) {

            this.f ++;

            if (this.f === 60) {

                this.emoji.frameName = "normal";

                this.game.add.tween(this.emoji.scale)
                    .to ({ x: 1.075, y: 1.075 * GameVars.scaleY }, 600, Phaser.Easing.Cubic.Out, true, 0, -1, true);
            }
        }
    }

    public matchOver(won: boolean): void {

        this.game.time.events.add(200, function(): void {
            this.emoji.frameName = won ? "victory" : "death";
        }, this);
        
        if (won) {
            this.game.add.tween(this.emoji)
                .to ({ y: this.emoji.y - 10 }, 150, Phaser.Easing.Cubic.Out, true, 0, -1, true);
        }
    }

    public onDownCell(): void {

        this.emoji.frameName = "normal";
    }

    public onUpCell(): void {

        this.emoji.frameName = "normal";
    }

    private onDownEmoji(): void {
        
        this.emoji.scale.set(1.15, 1.15 * GameVars.scaleY);

        this.emojiPressed = true;
    }

    private onUpEmoji(): void {
        
        GameManager.reset();
    }

    private onClickPause(): void {
        
        BoardManager.pauseGame();

        AudioManager.playSound("btn_click");
    }

    private onClickAudioButton(): void {
        
        AudioManager.toggleAudioState();

        if (GameVars.gameData && GameVars.gameData.muted) {
            this.audioOnButton.visible = false;
            this.audioOffButton.visible = true;
        } else {
            this.audioOnButton.visible = true;
            this.audioOffButton.visible = false;
        }
    }
}
